import { render, staticRenderFns } from "./confirmApprovePoviderFree.vue?vue&type=template&id=47d12e58&scoped=true&"
import script from "./confirmApprovePoviderFree.vue?vue&type=script&lang=ts&"
export * from "./confirmApprovePoviderFree.vue?vue&type=script&lang=ts&"
import style0 from "./confirmApprovePoviderFree.vue?vue&type=style&index=0&id=47d12e58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d12e58",
  null
  
)

export default component.exports